import classNames from "classnames";
import React from "react";
import { useState } from "react";
import {
  ViewGridIcon,
} from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";
import { MenuContent } from "../menu";
import { BsArrowRightSquare } from "react-icons/bs";
import { useQuery } from "react-query";
import Constants from "../../tools/constants.tools";
import { useAuth } from "../../middleware/auth.middleware";
import { AttenteGYMSPA } from "./attente";

export const HomeGymSpa = () => {
  const {role} = useAuth()
  const _gymspa = useQuery(['gymspa', role]);

  const [state, setState] = useState({
    revenuTotal: 0
  })


  return (
    <>
      <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
        <div className="grid gap-5 md:grid-cols-1 lg:grid-cols-2">
          <DashCard title="Attente" value={_gymspa?.data?.data?.attenteCount} onClick={() => {}}>
            <DashIcon
              icon={ViewGridIcon}
              iconColorClass="text-gray-50"
              bgColorClass="bg-indigo-600"
              className="mr-4"
            />
          </DashCard>

          <DashCard title="Rejeté" value={_gymspa?.data?.data?.rejeteCount} onClick={() => {}}>
            <DashIcon
              icon={ViewGridIcon}
              iconColorClass="text-gray-50"
              bgColorClass="bg-red-600"
              className="mr-4"
            />
          </DashCard>
        </div>
        <div className="grid gap-5 md:grid-cols-1 lg:grid-cols-2">
          <DashCard title="En cours" value={_gymspa?.data?.data?.en_coursCount} onClick={() => {}}>
            <DashIcon
              icon={ViewGridIcon}
              iconColorClass="text-gray-50"
              bgColorClass="bg-blue-600"
              className="mr-4"
            />
          </DashCard>

          <DashCard title="Terminé" value={_gymspa?.data?.data?.termineCount} onClick={() => {}}>
            <DashIcon
              icon={ViewGridIcon}
              iconColorClass="text-gray-50"
              bgColorClass="bg-green-600"
              className="mr-4"
            />
          </DashCard>
        </div>
      </div>
      <div className="pt-5">
        <AttenteGYMSPA/>
      </div>
    </>
  );
};

export function DashIcon({
  icon: Icon,
  iconColorClass = "text-purple-600",
  bgColorClass = "bg-purple-100",
  className,
}) {
  const baseStyle = "p-3 rounded-full";

  const cls = classNames(baseStyle, iconColorClass, bgColorClass, className);
  return (
    <div className={cls}>
      <Icon className="w-5 h-5" />
    </div>
  );
}

export function DashCard({ title, value, children: icon, onClick }) {
  return (
    <div
      className="flex items-center bg-white p-5 rounded-2xl cursor-pointer"
      onClick={onClick}
    >
      {icon}
      <div>
        <p className="mb-2 text-sm font-medium text-gray-600">{title}</p>
        <p className="text-lg font-semibold text-gray-700">{value}</p>
      </div>
    </div>
  );
}
